export default {
    'name': 'caret',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M19.7197 16.5508C20.0126 16.8437 20.4874 16.8437 20.7803 16.5508C21.0732 16.2579 21.0732 15.783 20.7803 15.4901L12.5099 7.21967C12.217 6.92678 11.7421 6.92678 11.4492 7.21967L3.17876 15.4901C2.88586 15.783 2.88586 16.2579 3.17876 16.5508C3.47165 16.8437 3.94652 16.8437 4.23942 16.5508L11.9795 8.81066L19.7197 16.5508Z\' fill=\'#026958\'/>'
}
